/**
 * Insertar preinforme Copilot → Plataforma (postMessage) o clipboard.
 * Contrato: docs/CONTRATO-UDV-AI-COPILOT.md
 */

export const COPILOT_INSERT_MESSAGE_TYPE = 'udv.copilot.insertReport'
export const COPILOT_INSERT_VERSION = 1

/**
 * @returns {string} origin permitido para postMessage (vacío = '*')
 */
export function getPlatformPostMessageOrigin() {
  try {
    if (
      typeof process !== 'undefined' &&
      process.env &&
      process.env.REACT_APP_PLATFORM_ORIGIN
    ) {
      return String(process.env.REACT_APP_PLATFORM_ORIGIN).trim()
    }
  } catch (e) {
    /* ignore */
  }
  return ''
}

/**
 * @param {*} result
 * @returns {object}
 */
export function buildCopilotInsertMessage(result) {
  const payload = {
    triage_level: result && result.triage_level ? String(result.triage_level) : '',
    urgency_reason:
      result && result.urgency_reason != null ? String(result.urgency_reason) : '',
    hallazgos: result && result.hallazgos != null ? String(result.hallazgos) : '',
    impresion_diagnostica:
      result && result.impresion_diagnostica != null
        ? String(result.impresion_diagnostica)
        : '',
    recomendacion:
      result && result.recomendacion != null ? String(result.recomendacion) : '',
  }
  return {
    type: COPILOT_INSERT_MESSAGE_TYPE,
    source: 'udv',
    version: COPILOT_INSERT_VERSION,
    payload,
  }
}

/**
 * Texto estructurado para pegar en sistemas externos.
 * @param {*} result
 * @returns {string}
 */
export function formatCopilotClipboardText(result) {
  const r = result || {}
  const lines = [
    `Triage: ${r.triage_level || '—'}`,
    r.urgency_reason ? `Urgencia: ${r.urgency_reason}` : null,
    '',
    'Hallazgos:',
    r.hallazgos || '—',
    '',
    'Impresión diagnóstica:',
    r.impresion_diagnostica || '—',
    '',
    'Recomendación:',
    r.recomendacion || '—',
  ]
  return lines.filter((x) => x != null).join('\n')
}

/**
 * @returns {boolean}
 */
export function isEmbeddedInIframe() {
  try {
    return typeof window !== 'undefined' && window.parent && window.parent !== window
  } catch (e) {
    return true
  }
}

/**
 * @param {*} result
 * @param {{ postMessageFn?: Function, clipboardWriteText?: Function, targetOrigin?: string }} [opts]
 * @returns {Promise<{ mode: 'postMessage'|'clipboard' }>}
 */
export async function insertCopilotReport(result, opts = {}) {
  const message = buildCopilotInsertMessage(result)
  const embedded = isEmbeddedInIframe()
  if (embedded) {
    const origin =
      opts.targetOrigin != null
        ? opts.targetOrigin
        : getPlatformPostMessageOrigin() || '*'
    const post =
      opts.postMessageFn ||
      ((msg, tgt) => {
        window.parent.postMessage(msg, tgt)
      })
    post(message, origin)
    return { mode: 'postMessage' }
  }
  const text = formatCopilotClipboardText(result)
  const write =
    opts.clipboardWriteText ||
    (typeof navigator !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'
      ? (t) => navigator.clipboard.writeText(t)
      : null)
  if (!write) {
    throw new Error('clipboard_unavailable')
  }
  await write(text)
  return { mode: 'clipboard' }
}
